import React, { Fragment } from 'react';
import ExternalLink from '../Navigation/Links/ExternalLink';

interface IProps {
  pdf?: boolean;
}

const NewLine = (props: IProps) => {
  const { pdf } = props;
  return (
    <Fragment>
      {
        pdf ? '\n' : <br />
      }
    </Fragment>
  );
}

const EPUDefinitionFootnote = (props: IProps) => {
  return (
    <Fragment>
      EPU (ECOMET Product Unit) is the unit of information used to cost ECMWF Products. For more details,
      please consult the
      &thinsp;
      <ExternalLink
        pdf={props.pdf}
        url="https://www.ecmwf.int/en/forecasts/accessing-forecasts/payment-rules-and-options/tariffs-examples"
      >
        ECMWF rules of the Information Cost calculation
      </ExternalLink>
      .
    </Fragment>
  );
};

const AdditionalChargesFootnote = (props: IProps) => {
  return (
    <Fragment>
      Please note that additional Volume and Service charges apply.
    </Fragment>
  );
};

const ResearchAndSmallBusinessFootnote = (props: IProps) => {
  return (
    <Fragment>
      Please note that discounts are only applied if all requirements are fulfilled. For more details,
      please consult the page on
      &thinsp;
      <ExternalLink
        pdf={props.pdf}
        url="https://www.ecmwf.int/en/forecasts/accessing-forecasts/payment-rules-and-options/tariffs"
      >
        ECMWF Data Pricing
      </ExternalLink>
      .
    </Fragment>
  );
};

const FeeWeaverAgreementFootnote = (props: IProps) => {
  return (
    <Fragment>
      Please note that the fee waiver scheme is only applied if all requirements are fulfilled.  For more details, please consult the page on
      &thinsp;
      <ExternalLink
        pdf={props.pdf}
        url="https://www.ecmwf.int/en/forecasts/accessing-forecasts/service-agreements"
      >
        Service Agreements and Use Cases
      </ExternalLink>
      .
    </Fragment>
  );
}

const LimitCapacityFootnoteLegacy = (props: IProps) => {
  return (
    <Fragment>
      Please note that the maximum amount of data which can be delivered per licence is 8000 GiB/day.
      This applies to licences from 01/07/2024 onwards.
    </Fragment>
  )
}

const LimitCapacityFootnote = (props: IProps) => {
  return (
    <Fragment>
      Please note that the maximum amount of data which can be delivered per agreement is 8000 GiB/day.
    </Fragment>
  )
}

const EPUOldLicenseNotice = (props: IProps) => {
  return (
    <Fragment>
      If your licence agreements pre-dates 01/07/2024 and you wish to amend your contract,
      please contact the Data Support Team directly via the
      &thinsp;
      <ExternalLink
        pdf={props.pdf}
        url="https://support.ecmwf.int"
      >
        ECMWF Support Portal
      </ExternalLink>
      .
      <NewLine {...props} />
      <NewLine {...props} />
      In support of the transition to Open Data, a new default costing version is available
      under the &quot;Select costing version&quot; dropdown in the web interface, named &quot;July 2025&quot;.
      It features the July 2024 Service Charge Model with 0.15 EPU to October 1st 2025 and 0 EPU (Open Data) onwards.
      The PDF download will contain the costing version which was applied in the web interface at the time of download.
    </Fragment>
  )
}

const ServicePackRecommendedFootnote = (props: IProps) => {
  return (
    <Fragment>
      Please note that pre-selected service package is recommended based on the average daily volume of your order. You can select a different service package in the next steps.
    </Fragment>
  )
}

export {
  EPUDefinitionFootnote,
  AdditionalChargesFootnote,
  ResearchAndSmallBusinessFootnote,
  FeeWeaverAgreementFootnote,
  LimitCapacityFootnoteLegacy,
  LimitCapacityFootnote,
  EPUOldLicenseNotice,
  ServicePackRecommendedFootnote
};
